import * as Yup from 'yup'

export type FormValues = {
  description: string
  files: Attachment[]
}

export const validationSchema = Yup.object({
  files: Yup.array(),
  description: Yup.string().required('Description is required')
})

export const initialValues: FormValues = {
  files: [],
  description: ''
}
